import { Outlet } from "react-router-dom";
import { Suspense, FC } from "react";


const AuthLayout = () => {
  return (
    <>
        <Suspense>
            <Outlet />
        </Suspense>
    </>
  )
}

export default AuthLayout